import Vue from 'vue'
import axios from '@/plugins/axios'

export const find = async ({ commit }, filter) => {
  try {

    const { data } = await axios.get('sms-template', {
      params: filter,
    })

    if (data?.smsTemplates) {
      commit('setRows', data.smsTemplates)

      return data.smsTemplates
    }

    return null
  } catch (err) {
    return err
  }
}

export const findById = async ({ commit }, id) => {
  try {
    const { data } = await axios.get(`sms-template/${id}`)

    if (data?.smsTemplate) {
      commit('setRow', data.smsTemplate)

      return data.smsTemplate
    }

    return null
  } catch (err) {
    return err
  }
}

export const create = async (_, body) => {
  Vue.prototype.$loading(true)

  try {
    return await axios.post('sms-template', body)
  } catch (err) {
    return err
  } finally {
    Vue.prototype.$loading(false)
  }
}


export const createTemplateRCS = async (_, body) => {
  Vue.prototype.$loading(true)
  console.log(body, 'CHEGOU O BODY AQUI - CREATE TEMPLATE RCS')
  
  try {
    const formData = new FormData()
    
    // Adicionar campos do formulário
    formData.append('name', body.name)
    formData.append('message', body.message || '')
    formData.append('type', body.type)
    formData.append('typeRcs', body.typeRcs)
    if (body.actionUrl) {
      formData.append('actionUrl', body.actionUrl)
    }
    if (body.buttonTitle) {
      formData.append('buttonTitle', body.buttonTitle)
    }
    formData.append('useVoiceOtp', body.useVoiceOtp)
    
    // Campos adicionais para RICHCARD
    if (body.title) {
      formData.append('titulo', body.title)
    }
    if (body.imageSize) {
      formData.append('tamanho', body.imageSize)
    }
    
    // Campos do fornecedor RCS
    if (body.brokerCode) {
      formData.append('brokerCode', body.brokerCode)
    }
    if (body.customerCode) {
      formData.append('customerCode', body.customerCode)
    }
    if (body.supplierType) {
      formData.append('supplierType', body.supplierType)
    }
    
    // Adicionar variáveis como JSON string
    if (body.variables && body.variables.length > 0) {
      formData.append('variables', JSON.stringify(body.variables))
    }
    
    // Adicionar dados do carousel como JSON string (para CAROUSEL)
    if (body.carouselMessages && body.carouselMessages.length > 0) {
      formData.append('carouselMessages', JSON.stringify(body.carouselMessages))
    }
    if (body.carouselTitles && body.carouselTitles.length > 0) {
      formData.append('carouselTitles', JSON.stringify(body.carouselTitles))
    }
    if (body.carouselSizes && body.carouselSizes.length > 0) {
      formData.append('carouselSizes', JSON.stringify(body.carouselSizes))
    }
    if (body.carouselActionUrls && body.carouselActionUrls.length > 0) {
      formData.append('carouselActionUrls', JSON.stringify(body.carouselActionUrls))
    }
    if (body.carouselButtonTitles && body.carouselButtonTitles.length > 0) {
      formData.append('carouselButtonTitles', JSON.stringify(body.carouselButtonTitles))
    }

    if (body.fallbackTitle) {
      formData.append('fallbackTitle', body.fallbackTitle)
    }

    if (body.fallbackMessage) {
      formData.append('fallbackMessage', body.fallbackMessage)
    }
    
    if (body.imageFile) {
      if (Array.isArray(body.imageFile)) {
        // Se for array, adicionar cada arquivo com o mesmo nome (para FilesInterceptor)
        body.imageFile.forEach(file => {
          if (file) {
            formData.append('imageFile', file)
          }
        })
      } else {
        // Se for arquivo único, adicionar normalmente
        formData.append('imageFile', body.imageFile)
      }
    }
    
    return await axios.post('sms-template/rcs', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  } catch (err) {
    return err
  } finally {
    Vue.prototype.$loading(false)
  }
}


export const update = async ({ state }, body) => {
  Vue.prototype.$loading(true)

  try {
    return await axios.put(`sms-template/${state.row.id}`, body)
  } catch (err) {
    return err
  } finally {
    Vue.prototype.$loading(false)
  }
}

export const updateTemplateRCS = async (_, body) => {
  Vue.prototype.$loading(true)
  console.log(body, 'CHEGOU O BODY AQUI - UPDATE TEMPLATE RCS')
  
  try {
    const formData = new FormData()
    
    // Adicionar campos do formulário
    formData.append('name', body.name)
    formData.append('message', body.message || '')
    formData.append('type', body.type)
    formData.append('typeRcs', body.typeRcs)
    if (body.actionUrl) {
      formData.append('actionUrl', body.actionUrl)
    }
    if (body.buttonTitle) {
      formData.append('buttonTitle', body.buttonTitle)
    }
    formData.append('useVoiceOtp', body.useVoiceOtp)
    
    // Campos adicionais para RICHCARD
    if (body.title) {
      formData.append('titulo', body.title)
    }
    if (body.imageSize) {
      formData.append('tamanho', body.imageSize)
    }
    
    // Campos do fornecedor RCS
    if (body.brokerCode) {
      formData.append('brokerCode', body.brokerCode)
    }
    if (body.customerCode) {
      formData.append('customerCode', body.customerCode)
    }
    if (body.supplierType) {
      formData.append('supplierType', body.supplierType)
    }
    
    // Adicionar variáveis como JSON string
    if (body.variables && body.variables.length > 0) {
      formData.append('variables', JSON.stringify(body.variables))
    }
    
    // Adicionar dados do carousel como JSON string (para CAROUSEL)
    if (body.carouselMessages && body.carouselMessages.length > 0) {
      formData.append('carouselMessages', JSON.stringify(body.carouselMessages))
    }
    if (body.carouselTitles && body.carouselTitles.length > 0) {
      formData.append('carouselTitles', JSON.stringify(body.carouselTitles))
    }
    if (body.carouselSizes && body.carouselSizes.length > 0) {
      formData.append('carouselSizes', JSON.stringify(body.carouselSizes))
    }
    if (body.carouselActionUrls && body.carouselActionUrls.length > 0) {
      formData.append('carouselActionUrls', JSON.stringify(body.carouselActionUrls))
    }
    if (body.carouselButtonTitles && body.carouselButtonTitles.length > 0) {
      formData.append('carouselButtonTitles', JSON.stringify(body.carouselButtonTitles))
    }
    
    if (body.imageFile) {
      if (Array.isArray(body.imageFile)) {
        // Se for array, adicionar cada arquivo com o mesmo nome (para FilesInterceptor)
        body.imageFile.forEach(file => {
          if (file) {
            formData.append('imageFile', file)
          }
        })
      } else {
        // Se for arquivo único, adicionar normalmente
        formData.append('imageFile', body.imageFile)
      }
    }
    
    return await axios.put(`sms-template/rcs/${body.id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  } catch (err) {
    return err
  } finally {
    Vue.prototype.$loading(false)
  }
}

export const remove = async (_, id) => {
  Vue.prototype.$loading(true)

  try {
    return await axios.delete(`sms-template/${id}`)
  } catch (err) {
    return err
  } finally {
    Vue.prototype.$loading(false)
  }
}
